<template>
  <div v-outside="onOutsideClick">
    <div v-outside="onOutsideClick" class="custom-select-container noselect" :class="[openClass, brandClass, {'half':halfWidth}, {'custom-select-container--invalid':error && form[paramName].$dirty}]">
      <label :for="(selectId ? selectId + '-': '') + 'custom-select-plus-'+paramName" class="custom-label" :class="[brandClass, {'_profileStyle':profileStyle}]">{{label}}</label>
      <div @click="toggle" class="input-wrapper" :class="brandClass" @keydown="inputWrapperKeyDown($event)" :id="(selectId ? selectId + '-': '') + 'input-wrapper'+paramName" role="button" @blur="blur" tabindex="0" :aria-label="t(`profile_${paramName}_select`)">
        <div v-show="isOpen && !profileStyle" class="dropdown-select-container"  :id="(selectId ? selectId + '-': '') + 'dropdown-select-container'" :class="brandClass">
          <div class="option option--select" :id="(selectId ? selectId + '-': '') + 'option-select'" :class="brandClass" >{{selectLabel}}</div>
        </div>
        <input
          tabindex="-1"
          v-show="!(isOpen && !profileStyle)"
          class="custom-select-input"
          :class="[brandClass,{'_profileStyle':profileStyle}]"
          :disabled="isDisabled"
          :id="(selectId ? selectId + '-': '') + 'custom-select-plus-'+paramName"
          :name="paramName"
          :placeholder="placeholder"
          readonly
          :value="selectionLabel"/>
        <div v-show="isOpen" class="custom-select-arrow-up" :class="[brandClass,{'_profileStyle':profileStyle},{'_error':error && form[paramName].$dirty}]"></div>
        <div v-show="isArrowDownVisible && !isOpen" class="custom-select-arrow-down" :class="[brandClass,{'_profileStyle':profileStyle},{'_error':error && form[paramName].$dirty}]"></div>
      </div>
      <div class="dropdown-wrapper" :id="(selectId ? selectId + '-': '') + 'dropdown-wrapper'+paramName">
        <div v-if="isOpen && options.length > 0" class="dropdown-container" :id="(selectId ? selectId + '-': '') + 'dropdown-container'" :class="brandClass">
          <div
            v-for="option in computedOptions"
            :id="(selectId ? selectId + '-' : '') + (option.label || t(option.translationKey)).trim().toLowerCase()"
            attr.value="(option.label || t(option.translationKey)).trim().toLowerCase()"
            :key="`option-${option.value}`"
            :class="[{'selected': modelValue=== option.value}, 'select-options-'+paramName]"
            class="option select-options"
            tabindex="0"
            role="input"
            @click="select(option)"
            @keydown="inputWrapperKeyDown"
          >
            {{ option.label || t(option.translationKey) }}
            <div
              v-if="modelValue === option.value"
              class="custom-select-icon"
              :class="brandClass"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="additionalMessage" :class="brandClass" v-html="additionalMessage">
    </div>
    <div class="custom-error" :class="brandClass" v-if="error && form[paramName].$dirty" aria-live="polite" role="alert" :aria-labelledby="(selectId ? selectId + '-': '') + 'custom-select-plus-'+paramName">{{error.message}}</div>
  </div>
</template>

<script>
import oneUtils from "../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";


const OutsideClick =  {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};




export default {

  name: "OneSelect",
  directives:{
    outside:OutsideClick
  },
  emits: ['update:modelValue','blur'],
  props: {
    t:{
      type: Function,
      required: true
    },
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    profileStyle:{
      type: Boolean,
      required: false,
      default: false
    },
    isArrowDownVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    additionalMessage: {
      type: String,
      required: false,
      default: null
    },
    errors: Array,
    halfWidth: Boolean,
    selectLabel: String,
    label: String,
    modelValue:{
      type: String,
    },
    placeholder: String,
    options: Array,
    disabled: Boolean,
    blankOption: Object,
    isSearchEnabled:{
      default: false,
      type: Boolean,
    },
    form:{
      type: Object,
      required: false
    },
    selectId: {
      default: null,
      type: String
    },
    paramName: String
  },
  data: () => ({
    listItemIds: [],
    isOpen: false,
    searchedString: ''
  }),
  mixins: [oneUtils.accessibilityMixin],
  watch: {
    "$store.state.oneSelectOpenUid": {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal && newVal && newVal !== this._.uid) {
          this.isOpen = false;
        }
      },
    },
  },
  computed: {
    openClass(){
      return this.isOpen ? 'opened' : 'closed'
    },
    error(){
      return this.errors.find(e=>e.thereIsTheError);
    },
    isDisabled() {
      return this.disabled || this.options.length === 0;
    },
    selectionLabel() {
      const option = this.computedOptions.find((o) => o.value === this.modelValue);
      if (!option) return "";
      if (option.label !== null && option.label !== undefined) return option.label;
      if (option.translationKey) return this.t(option.translationKey);
      return "";
    },
    computedOptions() {
      let options = [...this.options].sort((a,b)=>{
         const aLabel = a.label || this.t(a.translationKey) ;
         const bLabel = b.label || this.t(b.translationKey) ;
        return aLabel.localeCompare(bLabel);
      });
      if (this.blankOption) {
        // use this for showing blankOption as first element
        // options = options.unshift(this.blankOption);

        // use this for showing blankOption as last element
        options = options.concat(this.blankOption);
      }
      return options;
    },
  },
  methods: {
    inputWrapperKeyDown(event){
      if(this.isOpen){
        this.navigateInMenu(event, (this.selectId ? this.selectId + '-': '') + 'input-wrapper'+this.paramName, this.listItemIds, this.toggle, this.close);
        this.dropDownKeydown(event);
      }else{
        this.ariaClick(event);
      }
    },
    dropDownKeydown(event){
      if(this.isSearchEnabled){
        const allowed = 'abcdefghijklmnopqrstuvwxyz';
        if(allowed.includes(event.key.toLowerCase())){
          this.searchedString = this.searchedString+event.key;
          // const keyToFind = Object.keys(this.$refs).find(
          //   (elem)=>{return elem.startsWith(this.searchedString);}
          // );
          const elems = document.querySelectorAll('.select-options-'+this.paramName);

          const keyToFind = [...elems].find(
            (elem)=>{
              return elem.id.startsWith((this.selectId ? this.selectId + '-': '') + this.searchedString);
            }
          );
          if(keyToFind){
            keyToFind.focus();
          }
          // if(keyToFind){
          //   this.$refs[keyToFind][0].focus();
          // }
          clearInterval(this.activeTimeout);
          this.activeTimeout = setTimeout(() => {
            this.searchedString = '';          
          }, 1000);
        } 
      }
    },
    select(option) {
      this.$emit("update:modelValue", option.value);
      this.close();
    },
    onOutsideClick() {
      if(this.isOpen) {
        this.blur();
        this.close();
      }
    },
    blur() {
      this.$emit("blur");
    },
    toggle(e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (this.isDisabled) return;
      if(this.isOpen){
        this.onOutsideClick();
      }else{
        this.open();
      } 
    },
    open() {
      if (this.disabled) return;
      this.isOpen = true;
      this.$store.dispatch("setupOneSelectOpenUid", this._.uid);
      // this.startTypingListener();
      setTimeout(() => {
        const elem = document.getElementById((this.selectId ? this.selectId + '-': '') + 'dropdown-wrapper'+this.paramName);
        const listItems = elem.querySelectorAll(".select-options");
        this.listItemIds=[];
        listItems.forEach(item => this.listItemIds.push(item.id));
      }, 200);
    },
    close() {
      this.isOpen = false;
      this.$store.dispatch("setupOneSelectOpenUid", null);
      setTimeout(() => {
        const elem = document.getElementById((this.selectId ? this.selectId + '-': '') + 'input-wrapper'+this.paramName);
        if(elem)elem.focus();
      }, 200);
      // this.stopTypingListener();
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/_fonts.scss';
@import './styles/_variables.scss';

.additionalMessage{
    font-weight: 300;
    color: $grey5;
    margin-top: 5px;
    font-size: 12px;
    &.__d{
      color: white;
    }
  }
.custom-label{
  position: relative;
  display: inline-block;
  padding: 14px;
  margin: -14px;

  &.__rr {
      color: $grey;
      text-transform: uppercase;
      font-family: RivieraNights-Bold;

  }

  &.__m{
    color: black;
  }
  &._profileStyle{
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    color: $grey5;
    margin-bottom: -6px;
    &.__m{
      color: black;
    }
    &.__t{
      color: black;
    }
  }
  &.__t{
    font-family: ToyotaSemibold;
  }
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.custom-select-container {
  .input-wrapper{
    position: relative;
    &.__rr {
      margin-top: 8px;
    }
    &:focus{
      outline: none;
      input{
        border: 2px solid;
      }
    }
    &.__motorrad{
      &:focus{
        outline: none;
        input{
          border: 2px solid ;
        }
      }
    }
    &.__alphabet{
      &:focus{
        outline: none;
        input{
          border: 2px solid $alphabetfreshblue;
        }
      }
    }
  }
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  cursor: pointer;
  position: relative;
  &.half{
    width: 45%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  &.opened {
    .dropdown-container {
      box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
  }
  .custom-select-input{
    position: relative;
    cursor: pointer;
    font-family: inherit;
    border: 1px solid $grey;
    width: 100%;
    line-height: 1em;
    padding: 11px;
    padding-right: 45px;
    min-width: 0;
    color: $black;
    font-size: 16px;
    height: 48px;
    &:focus {
      outline: none;
      border: 2px solid;
    }
    &:disabled {
      color: rgba($black, 0.6);
    }
    &.__b {
      border: 2px solid $grey13;
    }
    &.__m{
      font-family: inherit;
      border: 1px solid black;
      font-family: MINISansSerif;
      font-size: 18px;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &:disabled {
        color: rgba(black, 0.6);
      }
    }
    &.__alphabet{
      &:disabled {
        color: rgba($grey10, 0.6);
      }
    }
    
    &.__t{
      color: black;
      font-family: ToyotaSemibold;
      &:disabled {
        color: rgba(black, 0.6);
      }
    }
    &.__motorrad{
      font-weight: bold;
      border: 1px solid $black;
      &:focus{
        input{
          border: 2px solid $black;
        }
      }
      &:disabled {
        color: rgba(black, 0.6);
      }
    }
    &.__d{
      box-shadow: 0 0 0 30px transparent !important;
      -webkit-box-shadow: 0 0 0 30px transparent !important;
      -webkit-text-fill-color: #fff!important;
      background: transparent;
      color: white !important;
      border: 1px solid;
      &:focus {
        outline: none;
        border: 2px solid white;
      }
    }
    &.__rr {
      font-family: RivieraNights-Light;

      &:disabled {
        color: $rrlightgrey;
        background-color: transparent !important;
      }
    }
    &:disabled{
      background-color: $grey6;
      &.__d{
        background-color: rgba($grey6, 0.6);
      }
    }
    &._profileStyle{
      height: 52px;
    }
  }
  


  label {
    font-size: 14px;
  }
  .dropdown-select-container{
    .option {
      padding: 15px;
      font-weight: 300;
      position: relative;
      box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-bottom: 1px solid $grey3;
      &.__rr {
        font-family: RivieraNights-Regular; 
        background: white;
      }
    }
    &.__m{
      .option{
        border: none;
        &.selected {
          background-color: black;
          color: white;
          border: none;
        }
      }
    }
  }
  .dropdown-wrapper {
    .dropdown-container {
      position: absolute;
      left: 0;
      max-height: 300px;
      overflow-y: auto;
      z-index: 8;
      width: 100%;
      background: white;
      &.__rr {
            color: $black;
      }
      &.__d{
        background-color: $bmwdarkmodebg;
        .option{
          &:hover{
             color: $bmwdarkmodebg;
          }
        }
      }
      .option {
        outline-offset: -4px;
        padding: 15px;
        font-weight: 300;
        position: relative;
        &.selected {
          font-weight: 400;
        }
        &:hover {
          background-color: $grey6;
        }
        .custom-select-icon {
          background-image: url('@/assets/default/light/check-default-light.svg');
          position: absolute;
          right: 15px;
          top: 20px;
          width: 13px;
          height: 10px;
          &.__rr {
             background-image: url('@/assets/rr/light/check-rr-light.svg');
          }
          &.__alphabet{
            background-image: url('@/assets/alphabet/light/check-alphabet-light.svg');
          }
          &.__motorrad {
            background-size: 100%;
            background-position-y: center;
            background-image: url('@/assets/motorrad/light/check-motorrad-light.svg');
          }
          &.__d{
            background-image: url('@/assets/default/dark/check-default-dark.svg');     
          }
        }
      }
    }
  }
  &.__m{
    font-size: 18px;
    font-family: MINISansSerif;
    
    &.opened {
      .custom-input {
        border: 2px solid black ;
      }
    }
    .dropdown-wrapper {
      .dropdown-container {
        &.__d{
          background-color: $minidarkmodebg;
          .option{
            &:hover{
              color: $minidarkmodebg;
            }
          }
        }
        .option {
          padding:  15px 15px 15px 13px;
          &.selected {
            color: white;
            background: black;
          }
          &:hover {
            background-color: $miniaddressbackground;
            color: black;
            
          }
          .custom-select-icon {
            display: none;
          }
        }
      }
    }
  
  }
  &.__alphabet{
    
    .dropdown-wrapper {
      .dropdown-container {
      
        .option {
          border-left: 4px solid transparent;
          &.selected {
            border-left: 4px solid $alphabetblue;
          }
          .custom-select-icon {
            display: none;
          }
        }
      }
    }
  
  }
  &.__t{
    font-family: Arial, Helvetica, sans-serif;
  }
  &.custom-select-container--invalid{
    .custom-label{
      color: black;
      &.__t{
        color: $toyotared;
      }
      &.__rr{
        color: $grey2;
      }
    }
    .custom-select-input{
      background: $errorbg;
      border: 2px solid $errorred;
      &:focus {
        outline: none;
        border: 2px solid black;
      }
      &.__t{
        font-family: Arial, Helvetica, sans-serif;
        color: $toyotared;
        border: 2px solid $toyotared;
      }
      &.__m{
        &__d{
          background: transparent;
          border: 2px solid $darkmodeRed;
          color: white;
        }
      }
     
      &.__rr {
        border: 2px solid $rrred;
      }
      &.__motorrad {
        background: $motorradred;
      }
      &.__d{
        background: transparent;
        border: 2px solid $darkmodeRed;
        color: white;
        &:focus {
          outline: none;
          border: 2px solid white;
        }
      }
      &.__alphabet{
        &:focus{
          border: 2px solid $alphabetfreshblue;
        }
      }
    }
  }
}
.custom-error{
  color: $red;
  font-size: 12px;
  line-height: 14px;
  margin-top: 5px;
  &.__d{
    color: $darkmodeRed;
  }
  &.__motorrad{
    color: $motorraderror;
  }
  &.__rr {
    color: white;
    font-family: RivieraNights-Regular;
    margin-top: 10px;
  }
}
.custom-select-arrow-up{
  position: absolute;
  right: 20px;
  top: 16px;
  width: 13px;
  height: 12px;
  background-image: url('@/assets/default/light/arrow-up-default-light.svg');
  &._profileStyle{
    background-image: url('@/assets/default/light/arrow-up-black-default-light.svg');
  }
  &.__m{
    background-image: url('@/assets/mini/light/arrow-up-mini-light.svg');
  }
  
  &.__rr {
    background-image: url('@/assets/rr/light/arrow-up-rr-light.svg');
  }
  &.__motorrad{
    background-image: url('@/assets/motorrad/light/arrow-up-motorrad-light.svg');
    top: 20px;
  }
  &.__d{
    background-image: url('@/assets/default/dark/arrow-up-default-dark.svg');
  }
  &._error{
    background-image: url('@/assets/default/light/arrow-up-error-default-light.svg');
  }
  &._profileStyle{
    top: 18px;
  }
}
.custom-select-arrow-down{
  position: absolute;
  right: 20px;
  top: 16px;
  width: 13px;
  height: 12px;
  background-image: url('@/assets/default/light/arrow-down-default-light.svg');
  &._profileStyle{
    background-image: url('@/assets/default/light/arrow-down-black-default-light.svg');
  }
  &.__m{
    background-image: url('@/assets/mini/light/arrow-down-mini-light.svg');
  }
  &.__rr {
    background-image: url('@/assets/rr/light/arrow-down-rr-light.svg');
  }
  &.__motorrad{
    background-image: url('@/assets/motorrad/light/arrow-down-motorrad-light.svg');
    top: 20px;
  }
  &.__d{
    background-image: url('@/assets/default/dark/arrow-down-default-dark.svg');
  }
  &._error{
    background-image: url('@/assets/default/light/arrow-down-error-default-light.svg');
  }
  &._profileStyle{
    top: 18px;
  }
}
</style>
